<template>
  <el-row class="text-align-left">
    <el-col :span="24">
      <Header></Header>
      <el-col :span="24" :offset="1" class="position-fixed">
        <el-col class="page-title">{{assessmentData.assessmentNo}}</el-col>
        <el-col class="upload-content">
          <el-col :xl="3" :lg="5" class="upload-content-btn">
            <el-button type="danger" @click="handleSave" :disabled="buttonStatus" >Save</el-button>
            <el-button type="danger" @click="close" v-if="this.assessmentId !== undefined">Close</el-button>
            <el-button type="danger" @click="close" v-else>Cancel</el-button>
          </el-col>
        </el-col>
        <div class="line"></div>
      </el-col>
      <el-col :span="23" :offset="1">
        <el-col :xl="3" :lg="4" :md="5" :sm="6">
          <div class="assessment-steps">
            <el-steps direction="vertical" :active="sectionList.length">
              <el-step class="assessment-step" :title="section.sectionEN" v-for="(section,index) in sectionList" :key="index" v-on:click.native="handleSection(index)" :status="section.status"></el-step>
            </el-steps>
          </div>
        </el-col>
        <el-col :xl="3" :lg="4" :md="5" :sm="6">&nbsp;</el-col>
        <el-col :xl="1" :lg="1" :md="1" :sm="1">
          <div class="line-vertical"></div>
        </el-col>
        <el-col :xl="21" :lg="20" :md="19" :sm="18" v-for="(section,index) in sectionList" :key="section.id">
          <div class="assessment-body" v-if="currentSection===index && section.type!== sectionType">
            <div v-html="descriptionContent" v-if="assessmentType===StakeholderType && currentSection===0" style="width: 70%"></div>
            <div class="description-body" v-html="descriptionChoiceTable" v-if="assessmentType===StakeholderType"></div>
            <div class="assessment-body-title">{{section.sectionEN}}</div>
            <div class="assessment-body-title">{{section.sectionTC}}</div>
            <div class="assessment-body-title">{{section.sectionSC}}</div>
            <div class="assessment-body-question" v-for="question in section.questionList" :key="question.id">
              <div class="assessment-body-subject">
                <span>{{question.sequence}}.&nbsp;</span><span v-html="question.questionEN"></span>
                <span v-if="question.multiSelect===1">&nbsp;&nbsp;[Multiple Selection]</span>
              </div>
              <div class="assessment-body-subject">&nbsp;&nbsp;&nbsp;&nbsp;<span v-html="question.questionTC"></span></div>
              <div class="assessment-body-subject">&nbsp;&nbsp;&nbsp;&nbsp;<span v-html="question.questionSC"></span></div>
              <div class="assessment-body-answer" v-for="option in question.optionList" :key="option.id">
                <div class="answer-class" v-html="option.optionEN"></div>
                <div class="answer-class" v-html="option.optionTC"></div>
                <div class="answer-class" v-html="option.optionSC"></div>
                <div class="alert-class" v-if="assessmentType===VendorType">
                  Alert:&nbsp;<span v-if="option.altered===1">TRUE</span><span v-else>FALSE</span>
                </div>
                <div v-if="assessmentType===VendorType">Score: {{option.score}}</div>
              </div>
            </div>
            <el-button @click="preSection" :disabled="currentSection===0">Previous</el-button>
            <el-button type="danger" @click="nextSection" :disabled="currentSection===sectionList.length-1">Next</el-button>
          </div>
          <div class="assessment-body" v-if="currentSection===index && section.type===sectionType && section.selectCount === 1">
            <!--English-->
            <div class="assessment-body-title">{{section.sectionEN}}</div>
            <div style="margin-bottom: 20px" v-html="section.descTopEN"></div>
            <div class="assessment-body-question">
              <el-table :data="section.questionList" empty-text="No Data" style="text-align: center;width: 80%;z-index:8;" height="670px" border>
                <el-table-column v-for="(question, index) in section.questionList" :fixed="true" v-if="index===0" :key="question.id">
                  <template slot-scope="scope" >
                    <span v-html="scope.row.questionEN"></span>
                  </template>
                </el-table-column>
                <el-table-column header-align="center" v-for="(option, index) in section.questionList[0].optionList" :label="option.optionEN" :key="index">
                  <template slot-scope="scope" style="text-align: center">
                    <span><el-radio :name="scope.row.id" :label="scope.row.optionList[index].id" disabled="true">&nbsp;</el-radio></span>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 20px" v-html="section.descBottomEN"></div>
            </div>
            <!--Traditional Chinese-->
            <div class="assessment-body-title">{{section.sectionTC}}</div>
            <div style="margin-bottom: 20px" v-html="section.descTopTC"></div>
            <div class="assessment-body-question">
              <el-table :data="section.questionList" empty-text="No Data" style="text-align: center;width: 80%;z-index:8;" height="670px" border>
                <el-table-column v-for="(question, index) in section.questionList" :fixed="true" v-if="index===0" :key="question.id">
                  <template slot-scope="scope" >
                    <span v-html="scope.row.questionTC"></span>
                  </template>
                </el-table-column>
                <el-table-column header-align="center" v-for="(option, index) in section.questionList[0].optionList" :label="option.optionTC" :key="index">
                  <template slot-scope="scope" style="text-align: center">
                    <span><el-radio :name="scope.row.id" :label="scope.row.optionList[index].id" disabled="true">&nbsp;</el-radio></span>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 20px" v-html="section.descBottomTC"></div>
            </div>
            <!--Simple Chinese-->
            <div class="assessment-body-title">{{section.sectionSC}}</div>
            <div style="margin-bottom: 20px" v-html="section.descTopSC"></div>
            <div class="assessment-body-question">
              <el-table :data="section.questionList" empty-text="No Data" style="text-align: center;width: 80%;z-index:8;" height="670px" border>
                <el-table-column v-for="(question, index) in section.questionList" :fixed="true" v-if="index===0" :key="question.id">
                  <template slot-scope="scope" >
                    <span v-html="scope.row.questionSC"></span>
                  </template>
                </el-table-column>
                <el-table-column header-align="center" v-for="(option, index) in section.questionList[0].optionList" :label="option.optionSC" :key="index">
                  <template slot-scope="scope" style="text-align: center">
                    <span><el-radio :name="scope.row.id" :label="scope.row.optionList[index].id" disabled="true">&nbsp;</el-radio></span>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 20px" v-html="section.descBottomSC"></div>
            </div>
            <el-button @click="preSection" :disabled="currentSection===0">Previous</el-button>
            <el-button type="danger" @click="nextSection" :disabled="currentSection===sectionList.length-1">Next</el-button>
           </div>
          <!--multiple section of Peer_section-->
          <div class="assessment-body" v-if="currentSection===index && section.type===sectionType && section.selectCount > 1">
            <!--English-->
            <div class="assessment-body-title">{{section.sectionEN}}</div>
            <div style="margin-bottom: 20px" v-html="section.descTopEN"></div>
            <div class="assessment-body-question">
              <el-table :data="section.questionList" empty-text="No Data" style="text-align: center;width: 80%;z-index:8;" height="670px" border>
                <el-table-column v-for="(question, index) in section.questionList" :fixed="true" v-if="index===0" :key="question.id">
                  <template slot-scope="scope">
                    <span v-html="scope.row.questionEN"></span>
                  </template>
                </el-table-column>
                <el-table-column header-align="center" v-for="(option, index) in section.questionList[0].optionList" :label="option.optionEN" :key="index">
                  <template slot-scope="scope" style="text-align: center">
                    <span><el-checkbox :id="scope.row.optionList[index].id" disabled>&nbsp;</el-checkbox></span>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 20px" v-html="section.descBottomEN"></div>
            </div>
            <!--Traditional Chinese-->
            <div class="assessment-body-title">{{section.sectionTC}}</div>
            <div style="margin-bottom: 20px" v-html="section.descTopTC"></div>
            <div class="assessment-body-question">
              <el-table :data="section.questionList" empty-text="No Data" style="text-align: center;width: 80%;z-index:8;" height="670px" border>
                <el-table-column v-for="(question, index) in section.questionList" :fixed="true" v-if="index===0" :key="question.id">
                  <template slot-scope="scope" >
                    <span v-html="scope.row.questionTC"></span>
                  </template>
                </el-table-column>
                <el-table-column header-align="center" v-for="(option, index) in section.questionList[0].optionList" :label="option.optionTC" :key="index">
                  <template slot-scope="scope" style="text-align: center">
                    <span><el-checkbox :id="scope.row.optionList[index].id" disabled>&nbsp;</el-checkbox></span>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 20px" v-html="section.descBottomTC"></div>
            </div>
            <!--Simple Chinese-->
            <div class="assessment-body-title">{{section.sectionSC}}</div>
            <div style="margin-bottom: 20px" v-html="section.descTopSC"></div>
            <div class="assessment-body-question">
              <el-table :data="section.questionList" empty-text="No Data" style="text-align: center;width: 80%;z-index:8;" height="670px" border>
                <el-table-column v-for="(question, index) in section.questionList" :fixed="true" v-if="index===0" :key="question.id">
                  <template slot-scope="scope" >
                    <span v-html="scope.row.questionSC"></span>
                  </template>
                </el-table-column>
                <el-table-column header-align="center" v-for="(option, index) in section.questionList[0].optionList" :label="option.optionSC" :key="index">
                  <template slot-scope="scope" style="text-align: center">
                    <span><el-checkbox :id="scope.row.optionList[index].id" disabled>&nbsp;</el-checkbox></span>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 20px" v-html="section.descBottomSC"></div>
            </div>
            <el-button @click="preSection" :disabled="currentSection===0">Previous</el-button>
            <el-button type="danger" @click="nextSection" :disabled="currentSection===sectionList.length-1">Next</el-button>
          </div>
        </el-col>
      </el-col>
    </el-col>
    <Footer @descriptionEvent="initDescription"></Footer>
  </el-row>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Header from '@/components/Header.vue';
import { callSaveQuestionnaire, previewQuestionnaire } from '@/services/answerer/questionnaire.service'
import { callSaveAsessment, callPreviewAssessment } from '@/services/answerer/assessment.service'
import Constant from '@/common/Constant';

export default {
  components: {
    Footer,
    Header
  },
  data () {
    return {
      assessmentData: {},
      buttonStatus: false,
      sectionList: [],
      currentSection: 0,
      assessmentType: '',
      VendorType: Constant.TYPE_VENDOR,
      StakeholderType: Constant.TYPE_STAKEHOLDER,
      assessmentStatusConfirmed: Constant.ASSESSMENT_STATUS_CONFIRMED,
      assessmentStatusSaved: Constant.ASSESSMENT_STATUS_SAVED,
      assessmentId: '',
      sectionType: Constant.SECTION_TYPE_PEER_EVALUATION,
      descriptionContent: '',
      descriptionChoiceTable: '',
      choiceLanguage: {}
    };
  },
  methods: {
    findAssessmentPreview () {
      let assessmentVo = JSON.parse(sessionStorage.getItem('assessmentInfo'));
      this.assessmentData = assessmentVo;
      this.sectionList = this.assessmentData.sectionList;
    },
    nextSection () {
      this.currentSection = this.currentSection < this.sectionList.length - 1 ? this.currentSection + 1 : this.sectionList.length - 1;
      this.handleStepStatus();
      document.documentElement.scrollTop = document.getElementsByClassName('assessment-body').offsetTop;
    },
    preSection () {
      this.currentSection = this.currentSection > 0 ? this.currentSection - 1 : 0;
      this.handleStepStatus();
      document.documentElement.scrollTop = document.getElementsByClassName('assessment-body').offsetTop;
    },
    handleSection (index) {
      this.currentSection = index;
      this.handleStepStatus();
      document.documentElement.scrollTop = document.getElementsByClassName('assessment-body').offsetTop;
    },
    handleStepStatus () {
      this.sectionList.forEach(item => {
        item.status = 'active';
      });
      this.sectionList[this.currentSection].status = 'process';
    },
    async handleSave () {
      this.$loading({fullscreen: true});
      if (this.assessmentType === Constant.TYPE_STAKEHOLDER) {
        await callSaveQuestionnaire(this.assessmentData).then(value => {
          if (value.code === Constant.RESPONSE_SUCCESS_CODE) {
            this.$alert('Saved successfully.', {
              confirmButtonText: 'OK'
            });
          }
          this.$router.push({name: 'StakeholderQuestionnaire'});
        });
      } else {
        await callSaveAsessment(this.assessmentData).then(value => {
          if (value.code === Constant.RESPONSE_SUCCESS_CODE) {
            this.$alert('Saved successfully.', {
              confirmButtonText: 'OK'
            });
          }
          this.$router.push({name: 'VendorAssessment'});
        });
      }
      this.$loading({fullscreen: true}).close();
    },
    async reviewAssessment () {
      let assessment = this.assessmentType === this.VendorType ? await callPreviewAssessment(this.assessmentId) : await previewQuestionnaire(this.assessmentId);
      this.assessmentData = assessment.data;
      this.sectionList = this.assessmentData.sectionList;
      if (this.assessmentData.status === this.assessmentStatusConfirmed) {
        this.buttonStatus = true;
      }
    },
    sortSectionInfo () {
      this.sectionList.sort(this.sortBySequecnce());
      this.sectionList.forEach(section => {
        section.questionList.sort(this.sortBySequecnce());
        section.questionList.forEach(question => {
          question.optionList.sort(this.sortBySequecnce());
        });
      });
    },
    close () {
      this.$confirm('Are you sure to leave this page?', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel'
      }).then(() => {
        window.close();
      }).catch(() => {
        console.log('Cancel');
      });
    },
    sortBySequecnce () {
      return function (a, b) {
        let value1 = a.sequence;
        let value2 = b.sequence;
        if (value1 < value2) {
          return -1;
        } else if (value1 > value2) {
          return 1;
        } else {
          return 0;
        }
      }
    },
    initDescription (data) {
      this.descriptionContent = data.content;
      this.descriptionChoiceTable = data.tableContent;
    }
  },
  mounted () {
    this.assessmentType = sessionStorage.getItem(Constant.ASSESSMENT_TYPE);
    this.$loading({fullscreen: true});
    this.assessmentId = this.$route.query.assessmentId;
    if (this.assessmentId !== undefined) {
      this.buttonStatus = true;
      this.reviewAssessment().then(value => {
        this.sortSectionInfo();
        this.handleStepStatus();
        this.$loading({fullscreen: true}).close();
      });
    } else {
      this.findAssessmentPreview();
      this.handleStepStatus();
      this.$loading({fullscreen: true}).close();
    }
  },
  beforeDestroy () {
    this.$loading({fullscreen: true}).close();
  }
}
</script>
<style scoped>
  .text-align-left {
    text-align: left;
  }

  .margin-left {
    margin-left: 15px;
  }

  .position-fixed {
    height: 170px;
    position: fixed;
    margin-top: 50px;
    background-color: #fff;
    z-index: 9;
    padding-top: 20px;
  }

  .page-title {
    font-size: 20px;
    line-height: 24px;
  }

  .upload-content {
    padding-top: 30px;
  }

  .line-vertical {
    width: 1px;
    height: 720px;
    background-color: #e6e6e6;
    top: 200px;
    position: fixed;
    margin-left: 30px;
  }

  .line {
    width: 94.66667%;
    height: 1px;
    background-color: #e6e6e6;
    position: fixed;
    top: 200px;
  }

  .assessment-body {
    padding-top: 230px;
    margin-bottom: 80px;
    padding-left: 65px;
  }

  .assessment-steps {
    margin-top: 230px;
    height: 450px;
    position: fixed;
  }

  >>>@media screen and (max-width: 1360px) {
    .el-step.is-vertical .el-step__title{
      max-width: 160px;
    }
  }

  >>>@media screen and (max-width: 820px){
    .assessment-steps {
      display: none;
    }

    .line-vertical {
      display: none;
    }

    .assessment-body {
      position: absolute;
      left: 0;
    }
  }

  .assessment-body-title {
    color: #2d2d2d;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 20px;
  }

  .description-body{
    position: -webkit-sticky;
    position: sticky;
    background-color: #fff;
    z-index: 9;
    box-shadow: 0 0 18px 3px rgba(26, 102, 255, 0.1);
    top: 205px;
    padding: 15px 20px;
    margin: 0 20px 10px 0;
  }

  .assessment-body-question {
    margin-bottom: 25px;
    vertical-align: top;
    line-height: 25px;
  }

  .assessment-body-subject {
    color: #000;
    padding-right: 20px;
    margin-bottom: 4px;
  }

  .assessment-body-answer {
    margin: 20px 10px 0 10px;
    padding: 15px;
    border-left: 3px solid #5E89ED;
    display: inline-block;
    width: 250px;
    background-color: rgba(94, 137, 237, 0.1);
    vertical-align: top;
    color: #666;
  }

  .assessment-body .el-button {
    width: 120px;
    height: 40px;
    margin-right: 30px;
    margin-top: 20px;
    font-size: 16px;
  }

  .alert-class {
    margin-top: 20px;
    margin-bottom: 4px;
  }

  .answer-class {
    margin-bottom: 4px;
  }

  >>>@media screen and (max-width: 1280px) {
    .el-upload-list {
      left: 195px;
    }

    .assessment-body {
      padding-left: 50px;
    }

    .assessment-body-answer {
      margin: 20px 5px 0 15px;
      width: 240px;
    }
  }

  >>>.el-button {
    border-color: #5e89ed;
    color: #5e89ed;
  }

  >>>.el-button:hover {
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button:focus {
    border-color: #5e89ed;
    background-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger {
    background-color: #5e89ed;
    border-color: #5e89ed;
    color: #fff;
  }

  >>>.el-button--danger:hover {
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-button--danger:focus {
    background-color: #4b6ebe;
    border-color: #4b6ebe;
    color: #fff;
  }

  >>>.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
    color: #c0c4cc;
    cursor: not-allowed;
    background-image: none;
    background-color: #fff;
    border-color: #ebeef5;
  }
  >>>.el-button--danger.is-disabled, .el-button--danger.is-disabled:active, .el-button--danger.is-disabled:focus, .el-button--danger.is-disabled:hover {
    color: #fff;
    background-color: #9ecdfde6;
    border-color: #9ecdfde6;
  }

  >>>.el-step__icon {
    background-color: #c0c4cc;
  }

  >>>.el-step__head.is-wait {
    color: #ffffff;
  }

  >>>.el-step__head.is-finish {
    color: #ffffff;
    border-color: #5e89ed;
    cursor: pointer;
  }

  >>>.el-step__title.is-finish {
    color: #5e89ed;
    cursor: pointer;
  }

  >>>.el-step__title.is-finish:hover {
    color: #ffa600;
    font-weight: normal;
  }

  >>>.el-step__head.is-finish .el-step__line {
    background-color: #c0c4cc;
  }

  >>>.el-step__head.is-process {
    color: #ffffff;
    border-color: #5e89ed;
  }

  >>>.el-step__head.is-finish .el-step__icon {
    background-color: #5e89ed;
  }

  >>>.el-step__head.is-process .el-step__icon {
    background-color: #5e89ed;
  }

  >>>.el-step__title.is-process {
    color: #5e89ed;
  }

  >>>.el-step__description.is-process{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid;
    border-color: #5e89ed;
    background-color: #fff;
    padding-right: 0;
    position: relative;
    right: 39px;
    margin-top: -5px;
  }

  >>>.el-step.is-vertical .el-step__title{
    max-width: 210px;
    line-height: 20px!important;
    float: left;
  }

  >>>.el-step__title.is-wait {
    color: #5e89ed;
    cursor: pointer;
  }

  >>>.el-step__title.is-wait:hover {
    color: #ffa600;
  }

  >>>.el-step__icon {
    background-color: #5e89ed;
  }

  >>>.el-step__head.is-wait {
    border-color: #5e89ed;
  }

  >>>.el-step__line {
    background-color: #ececec;
  }

  >>>.el-step__head.is-finish .el-step__line {
    background-color: #ececec;
  }

  >>>.el-radio {
    margin-left: 15px;
  }

  >>>.el-upload-list__item.is-success:focus:not(:hover) .el-icon-close-tip {
    display: none;
  }

  .el-upload-list__item.is-success focusing {
    /* outline-color: black !important; */
  }

  >>>.el-step__head.is-active{
    color: #ffffff;
    border-color: #5e89ed;
  }

  >>>.el-step__head.is-active .el-step__icon{
    background-color: #5e89ed;
  }

  >>>.el-step__title.is-active{
    color: #5e89ed;
  }

  >>>.el-step__description.is-active{
    width: 30px;
    border-radius: 50%;
    background-color: #fff;
    padding-right: 0;
    margin-top: -37px;
    position: relative;
    right: 39px;
  }

  >>>.el-step__title.is-active:hover{
    font-weight: bold;
  }

  >>>.el-radio {
    margin-left: 15px;
  }

  >>>a{
    color: #5e89ed;
  }
</style>



// WEBPACK FOOTER //
// src/pages/QuestionnairePreview.vue